import { makeColorSchema } from '../color-utils';
export const communityStyle = makeColorSchema('#00a0b5');
//# sourceMappingURL=community.style.js.map